var templateUrl = require('./main-header.html');

angular.module('ciApp').component('mainHeader', {
  templateUrl: templateUrl,
  controllerAs: '$mainHeaderCtrl',
  controller: ['$state', 'AuthService', '$rootScope', 'classicUrl', MainHeaderController]
});

function MainHeaderController($state, AuthService, $rootScope, classicUrl) {
  var ctrl = this;

  ctrl.classicUrl = classicUrl;

  ctrl.goHome = function() {
    AuthService.goHome();
  };

  function updateUsername() {
    var currentUser = AuthService.currentUser();
    if (currentUser) {
      ctrl.currentUser = currentUser;
      ctrl.isLoggedIn = true;
    } else {
      ctrl.currentUser = null;
      ctrl.isLoggedIn = false;
    }
  }

  $rootScope.$on('userLoggedIn', updateUsername);
  $rootScope.$on('userLoggedOut', updateUsername);
  updateUsername();

  ctrl.isLoggedIn = AuthService.isLoggedIn();

  ctrl.toggleSidebar = function() {
    ctrl.openSidebar = !ctrl.openSidebar;
  };
}



// WEBPACK FOOTER //
// ./common/components/main-header/main-header.component.js